import React from 'react';
import { Button, Spin, Select, Modal, DatePicker } from 'antd';
import { hashHistory } from 'react-router'

import DataService from '../../lib/DataService';
import SharedTools from '../../lib/SharedTools';

import CurrentRoleStore from '../../stores/CurrentRoleStore';
import AttendanceTable from '../share/AttendanceTable';

import moment from 'moment';
const { MonthPicker } = DatePicker;

const Option = Select.Option;

export default class StudentAttendanceStatisticsIndexPage extends React.Component {
  constructor(props) {
    super(props);
    let semester = SharedTools.getCurrentSemester(), currentRole = CurrentRoleStore.getCurrentRole();
    let semesters = SharedTools.getAllSemesters(semester, SharedTools.getCurrentSemester(currentRole.created_at));

    this.state = {
      semester,
      currentRole,
      semesters,
      setAttendance: false,
      editAttendance: false,
      visible: false,
      loading: false,
      columns: [],
      classes: [],
      schoolId: props.params.schoolId,
      setStatus: true,

      showAttendance: false,
      date: new Date()
    }

    this.selectSemester = this.selectSemester.bind(this)
    this.goSetCalendarPage = this.goSetCalendarPage.bind(this)
    this.callBack = this.callBack.bind(this)

  }

  componentDidMount() {
    if (this.state.currentRole.associatName == 'classRecord') {
      hashHistory.push(`student-attendance/schools/${this.state.schoolId}/attendance-statistics/classes/${this.state.currentRole.associatObj.id}`);
    } else {
      this.getClassesAttendance(this.state.semester)
      this.getSumSetGrades()
    }
  }

  getSumSetGrades() {
    let data = {
      school_id: this.state.schoolId,
      semester: this.state.semester
    }
    DataService.getSumSetGrades(data).then((res) => {
      let count = 0;
      res.forEach((grade) => {
        count += grade.setted;
      })
      this.setState({
        setStatus: count > 0 ? true : false
      })
    }).catch ((error) => {
      console.log(error)
    });
  }

  toolTableColumns(month_rates) {
    let columns = [];
    month_rates.map((month) => {
      columns.push({
        title: month.month + '月缺勤率',
        dataIndex: 'month_' + month.month.toString(),
        render: (text, record) => <span>{record['month_' + month.month] ? record['month_' + month.month] : '-'}</span>
      })
    })

    columns.unshift({ title: '班级', dataIndex: 'name' })
    columns.push({ title: '学期缺勤率', dataIndex: 'semester_rate' })
    columns.push({ title: '操作', dataIndex: 'operation', render: (text, record) => <span className="header-operation" onClick={this.goNextPage.bind(this, record)}>查看</span>})

    return columns
  }

  goNextPage(record) {
    hashHistory.push(`student-attendance/schools/${this.state.schoolId}/attendance-statistics/classes/${record.id}`);
  }

  getClassesAttendance(semester) {
    this.setState({
      loading: true
    })
    DataService.getStudentStatistic({school_id: this.state.schoolId, semester}).then(res => {
      let columns = []
      if (res && res.length > 0) {
        columns = this.toolTableColumns(res[0].month_rates)
      }

      let classes = [];
      res.forEach(data => {
        let newObj = { id: data.id, name: data.name, semester_rate: ((data.semester_rate * 100).toFixed(1) + '%') }, dataObj = {};
        data.month_rates.forEach((month) => {
          dataObj['month_' + month.month] = (month.rate * 100).toFixed(1) + '%';
        })
        classes.push(Object.assign(newObj, dataObj));
      });
      this.setState({
        classes,
        columns,
        loading: false
      })
    }, (error) => {
      console.log(error);
      this.setState({
        loading: false,
      })
    })
  }

  selectSemester(value) {
    if (value != this.state.semester) {
      this.setState({
        semester: value,
      }, () => {
        this.getClassesAttendance(value)
      })
    }
  }

  callBack(id) {
    hashHistory.push(`student-attendance/schools/${this.props.params.schoolId}/attendance-statistics/classes/${id}`);
  }

  goSetCalendarPage() {
    hashHistory.push(`student-attendance/schools/${this.props.params.schoolId}/attendance-calendar`);
  }

  // 导出报告
  onChangeDate(date, dateString) {
    this.setState({
      date: dateString
    })
  }

  handleOk() {
    let year = moment(this.state.date).format('YYYY'), month = moment(this.state.date).format('MM');
    let url = `http://da.ddycj.com/api/v1/schools/student_clock_on_report?year=${year}&month=${month}&school_id=${this.state.schoolId}`
    window.open(url);
    this.setState({
      showAttendance: false
    })
  }

  disabledDate(current) {
    return current > moment().endOf('month');
  }

  _withoutAttendanceCalendarView() {
    return (
      <div className="without-attendance-calendar-view">
        <div className="view-header">请先完成“学生考勤校历”</div>
        <div className="view-label">查看考勤统计需要先去“学生考勤日历”页面设置本学期需要考勤的天数。</div>
        <Button type="primary" onClick={this.goSetCalendarPage}>去设置 学生考勤校历</Button>
      </div>
    )
  }

  render() {
    let { columns, classes, loading, setStatus, date } = this.state;
    const monthFormat = 'YYYY-MM';
    return (
      <div className="student-attendance-statistics-index-page attendance-table-container">
          <div className="page-header">
            学生考勤情况
            <Select value={String(this.state.semester)} style={{ width: 145 }} onChange={this.selectSemester} className="select-semester">
              {this.state.semesters.map((semester, index) => <Option value={String(semester.semester)} key={index}>{semester.semesterToString}</Option>)}
            </Select>
            {setStatus ?
            <Button type="primary" style={{ marginLeft: 30}} onClick={() => this.setState({showAttendance: true})}>月度考勤报告导出</Button>:null}
        {setStatus ?
          <AttendanceTable columns={columns} data={classes} loading={loading} callBack={this.callBack} /> : this._withoutAttendanceCalendarView()}
        </div>
        <Modal
          title="学生考勤月度报告"
          visible={this.state.showAttendance}
          onOk={this.handleOk.bind(this)}
          onCancel={() => this.setState({ showAttendance: false })}
          wrapClassName="export-attendance-modal"
          footer={[
            <Button key="submit" type="primary" loading={loading} onClick={this.handleOk.bind(this)}>
              确认导出
            </Button>,
          ]}
        >
          <MonthPicker format={monthFormat} onChange={this.onChangeDate.bind(this)} allowClear={false} disabledDate={this.disabledDate} defaultValue={moment(new Date())}/>
        </Modal>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/attendance/StudentAttendanceStatisticsIndexPage.jsx